import { FormioForm } from '@formio/angular';
import { FormioValues } from './formio.model';

export enum ContentType {
  None = 0,
  VideoAvi = 1,
  DocumentCsv = 2,
  DocumentWord = 3,
  DocumentWord2007 = 4,
  ImageGif = 5,
  ImageJpeg = 6,
  ImageJpg = 7,
  VideoMp4 = 8,
  VideoMpeg = 9,
  ImagePng = 10,
  DocumentPdf = 11,
  DocumentPowerPoint = 12,
  DocumentPowerPoint2007 = 13,
  DocumentExcel = 14,
  DocumentExcel2007 = 15,
}

export enum DocumentType {
  None,
  Pdf,
  Formio,
  Video,
  FlexForm,
}

export interface DocumentData {
  documentType: DocumentType;
}

export interface NoData extends DocumentData {
  documentType: DocumentType.None;
}

export interface PdfData extends DocumentData {
  documentType: DocumentType.Pdf;
  base64Pdf: string;
}

export interface FormioData extends DocumentData {
  documentType: DocumentType.Formio | DocumentType.FlexForm;
  formioForm?: FormioForm;
  formioValues?: FormioValues;
  eSignFlow?: boolean;
  isSignOffAfterClientCompletion?: boolean;
  flexFormData?: {
    htmlSource: string;
    jsonData: string;
  };
}

export interface VideoData extends DocumentData {
  documentType: DocumentType.Video;
  url: string;
}

export function newNoData(): NoData {
  return {
    documentType: DocumentType.None,
  };
}

export function newPdfData(data?: Partial<PdfData>): PdfData {
  return {
    base64Pdf: '',
    ...data,
    documentType: DocumentType.Pdf,
  };
}

export function newVideoData(data?: Partial<VideoData>): VideoData {
  return {
    url: '',
    ...data,
    documentType: DocumentType.Video,
  };
}

export interface ChartNoteSignatureInvitationData {
  chartNoteId?: number;
  signeeEntityId?: number;
  signeeUserAgent: string;
  signedUsingApplication: string;
}
